export enum ReconciliationViewBannerPage {
  Reconciliation = 'reconciliation',
  Transactions = 'transactions',
}
